
import '../styles/PartyButton.css';     // or correct relative path

const PartyButton = ({ onClick }) => (
  <div className="party-button-container">

<button className="party-button" onClick={onClick}>
      Party
    </button>
  </div>
);



export default PartyButton;
